import React from 'react'
import styled from 'styled-components';
import { colors } from '../styles/colors';


const Container = styled.div`
    display: flex;
    flex-direction: column;
`;
const Row = styled.div`
    display: grid;
    grid-template-columns: 1fr 0.5fr 1fr;
		justify-items: center;
		align-items: center;
		margin-bottom: 30px;
		padding: 0 20px;
`;

const Logo = styled.img`
    margin: 0 15px;
		max-width: 200px;
		width: 100%;
`;
const Header = styled.h1`
    color: ${colors.headings};
    text-align: center;
    font-weight: 900;
    max-width: 650px;
    margin: 0 auto;
    margin-bottom: 30px;
		font-size: 70px;
		text-transform: capitalize;
		
		@media only screen and (max-width: 600px) {
			font-size: 50px;
		}
`;

const Plus = styled.div`
margin:0;
padding:0;
font-size: 55px;
font-weight: 600;
`;

const LogosHeader = ({ header }) => (
    <Container>
        <Row>
            <Logo src={require('../images/wipay.png')}/>
						<Plus>+</Plus>
            <Logo src={require('../images/shopify.png')}/>
        </Row>
        <Header>{header}</Header>
    </Container>
)

export default LogosHeader